import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routes = [
  {
    path: '*',
    redirect: '/robPacket'
    // redirect: to => {
    //   if (localStorage.getItem('version') === 'old') {
    //     return '/oldhome'
    //   } else {
    //     return '/home'
    //   }
    // }
  },
  // 抢红包
  {
    path: '/robPacket',
    name: 'robPacket',
    component: () => import('@/views/tel/robPacket/index.vue'),
    meta: {
      title: '抢红包'
    }
  },
  {
    path: '/packetDetail',
    name: 'packetDetail',
    component: () => import('@/views/tel/robPacket/detail.vue'),
    meta: {
      title: '红包详情'
    }
  },
  // 群红包
  {
    path: '/hongbao',
    name: 'Hongbao',
    component: () => import('@/views/tel/robPacket/hongbao.vue'),
    meta: {
      title: '发红包'
    }
  },
  // 联系人
  {
    path: '/peopleList',
    name: 'PeopleList',
    component: () => import('@/views/tel/robPacket/peopleList.vue'),
    meta: {
      title: '指定领取人'
    }
  }
]

const router = new VueRouter({
  // 记录上个页面的滚动位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
